<template>
  <div class="demo">lklkl</div>
</template>
<script>
  export default {
    data() {
      return {
        // 参数说明  anime.js还提供了诸如play、pause和restart方法来控制动画的执行、暂停和重新运行动画。也可以使用seek()方法来跳帧运行动画。
        anime: {
          //targets: 用来指定要运动的元素，可以使用类似CSS选择器来选择元素，或者是下面几种方法来选择元素
          //DOM选择方法document.querySelector('.ball')或者是document.querySelectorAll('.ball')方法;
          //js数组的方式['.ball']
          //js对象的方式{elementName: 'ball'}
          // 如果你要操作的元素有多个值或者是要操作多个元素，可以这样做：targets: ['.ball', '.kick'],
          targets: '.ball',
          // translateY 操作元素做出变化的属性,和CSS中操作元素的方法非常相似。
          translateY: '50vh',
          // duration 动画的运行时间。 如果要延迟执行动画，可以使用delay这个参数来指定动画延迟时间
          duration: 300,
          // loop 定义动画是否循环运行默认值是false，即动画只运行一次。当然也可以指定具体的数字来定义动画运行的次数
          // 或者是定义为true一只无限循环运行下次
          loop: true,
          // direction 定义是否应该轮流反向播放动画。有三个值default、alternate和reverse。alternate表示动画应该轮流反向播放。reverse表示反方向运行。
          direction: 'alternate',
          // easing 它是用来定义动画运行速度曲线的，与CSS3中的动画曲线一样。
          // console.log(anime.easings); 可查看anime中有哪些速度曲线
          easing: 'easeInCubic',
        },
      }
    },
    methods: {
      test() {
        // anime.js还提供了诸如play、pause和restart方法来控制动画的执行、暂停和重新运行动画。也可以使用seek()方法来跳帧运行动画。
        // 下面通过按钮分别来控制踢球和球运动的动画效果。
        //Animating the kick
        // var kickBall = anime({
        //   targets: '.kick',
        //   scale: 1.2,
        //   duration: 300,
        //   delay: 100,
        //   easing: 'easeInCubic',
        //   autoplay: false,
        // })
        // //Animating the ball
        // var movingBall = anime({
        //   targets: '.ball',
        //   translateX: '70vw',
        //   scale: 1.5,
        //   easing: 'easeOutBounce',
        //   delay: kickBall.duration + 100,
        //   autoplay: false,
        // })
        // btnPlay.addEventListener('click', function (e) {
        //   e.preventDefault()
        //   kickBall.play()
        //   movingBall.play()
        // })
        // 这里有两点需要注意的是：
        // 为来在页面加载完的时候，不运行动画，需要设置autoplay的值为false；
        // 只需要把对应的动画方法和play()绑定就可以用按钮来控制动画的运行和暂停了。
        // ---------------分-----割-----线--------------------------
        // 使用anime.js来操作SVG
        // 最后来看看使用anime.js来操作SVG。
        // 在开始之前，把每一个SVG中的path元素都赋予一个CSS类，这样方便使用animejs来操作。
        // 比如，要实现一个眼睛的动画效果：
        // var movingEyes = anime({
        //   targets: ['.inner-left-eye', '.inner-right-eye'],
        //   cy: 400,
        //   duration: 500,
        //   delay: function (el, index) {
        //     var singleDelay = index === 0 ? 300 : index * 500
        //     return singleDelay
        //   },
        //   autoplay: false,
        // })
        // delay这个属性，是使用一个函数来返回值的，这样可以更灵活的控制动画的延迟时间。通过元素的索引值来返回不同的延迟的时间。
        // 如果元素的索引值是0即左边的眼睛的延迟时间是300毫秒，如果是2即右边的眼睛延迟500毫秒来运行动画。
      },
    },
  }
</script>
<style lang="scss" scoped>
  .demo {
    height: 100%;
    background: #fff;
  }
</style>
